import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { book, book_page, book_count } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";

function BookRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);

    // 讀取點數申請記錄
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${book_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setRequestList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    


    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${book_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);


    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        
        let finalValue;
        if (type === 'checkbox') {
            finalValue = switchHelper(checked);
        } else if (type === 'number') {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prevData => ({
            ...prevData,
            [name]: finalValue
        }));
    };

    // 更新申請記錄
    const saveChanges = async () => {
        try {
            const dataToSend = {
                ...updatedData,
                timestamp: new Date().toISOString(), 
                status: updatedData.status || '審核中',  // 確保 status 是有效值，預設為 '處理中'
                requested_date: formatToMysqlDatetime(new Date()),
            };
    
            console.log("Data to Send:", dataToSend); // 確認要發送的資料格式
    
            await axios.put(`${book}`, dataToSend, { headers: {
                Authorization: `Bearer ${token}`,
                token: token
              } });
    
            setRequestList(prevList =>
                prevList.map(req => (req.receive_book_id  === updatedData.receive_book_id  ? dataToSend : req))
            );
    
            setEditingRequest(null);
        } catch (error) {
            console.error('Error updating request:', error);
        }
    };

    const formatToMysqlDatetime = (dateInput) => {
        const date = new Date(dateInput);
        const pad = (n) => (n < 10 ? '0' + n : n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
               `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
    
    // 用法

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        
        setUpdatedData(prevData => {
            const currentSubjects = prevData.core_subject ? prevData.core_subject.split(',') : [];
            let updatedSubjects;
            
            if (checked) {
                // 如果選中，新增該學科
                updatedSubjects = [...currentSubjects, value];
            } else {
                // 如果取消選中，移除該學科
                updatedSubjects = currentSubjects.filter(subject => subject !== value);
            }
    
            return {
                ...prevData,
                core_subject: updatedSubjects.join(',')  // 將陣列轉為逗號分隔的字串
            };
        });
    };
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    return (
        <>
            <div className="mt100 container">
            {loading ? (
                    <p>載入中...</p>
                ) : (
                <div className="mt-2">
                    <table className="table table-striped border table-responsive">
                        <thead>
                            <tr>
                                <th>學生姓名</th>
                                <th>領書科目</th>
                                <th>領書日期</th>
                                <th>寄件地址</th>
                                <th>狀態</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                        {requestList.map((request) => (
                                <tr key={request.receive_book_id }>
                                    {editingRequest && editingRequest.receive_book_id  === request.receive_book_id  ? (
                                        <>
                                            <td colSpan={10}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">學生姓名</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="student_name"
                                                                    value={updatedData.student_name}
                                                                    onChange={handleInputChange}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>   
                                                        <div className="col-md-6">
                                                            <div className="d-flex flex-wrap align-items-center">
                                                                <label className="form-label me-3">領書科目</label>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectFAR"
                                                                        value="FAR"
                                                                        checked={updatedData.core_subject?.includes("FAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectFAR">FAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectREG"
                                                                        value="REG"
                                                                        checked={updatedData.core_subject?.includes("REG")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectREG">REG</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectAUD"
                                                                        value="AUD"
                                                                        checked={updatedData.core_subject?.includes("AUD")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectAUD">AUD</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectBAR"
                                                                        value="BAR"
                                                                        checked={updatedData.core_subject?.includes("BAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">BAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectISC"
                                                                        value="ISC"
                                                                        checked={updatedData.core_subject?.includes("ISC")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">ISC</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectTCP"
                                                                        value="TCP"
                                                                        checked={updatedData.core_subject?.includes("TCP")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">TCP</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">領書日期</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="date"
                                                                    name="requested_date"
                                                                    value={updatedData.requested_date || ''}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{request.student_name || "未提供姓名"}</td>
                                            <td>{request.core_subject || "無學科"}</td>
                                            <td>{dateHelper(request.requested_date, "date")}</td>
                                            <td>{request.address || ""}</td>
                                            <td>{request.status || ""}</td>
                                            <td>{formatDate(request.timestamp)}</td>
                                            <td>{request.memo || ""}</td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                )}
            </div>
        </>
    );
}

export default BookRequest;
